export default __webpack_public_path__ + "static/media/3.748b2226.png";